import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
export const IconLineHeightPlaceholder = styled.span.withConfig({
    shouldForwardProp: isPropValid,
}) `
  overflow: hidden;
  word-break: normal;
  width: 0;
  &:before {
    content: "\\00a0"; // <- Unicode for &nbsp;
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSWNvbkxpbmVIZWlnaHRQbGFjZWhvbGRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1RleHRXaXRoSWNvbkxheW91dC9zdHlsZWQvSWNvbkxpbmVIZWlnaHRQbGFjZWhvbGRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLFdBQVcsTUFBTSx3QkFBd0IsQ0FBQztBQUNqRCxPQUFPLE1BQU0sTUFBTSxtQkFBbUIsQ0FBQztBQUV2QyxNQUFNLENBQUMsTUFBTSx5QkFBeUIsR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUM5RCxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTs7Ozs7OztDQU9ELENBQUMifQ==